<template>
  <PageTable />
</template>
<script>
import PageTable from './table'
export default {
  name: 'financial-finSet-custBudget',
  components: { PageTable },
}
</script>
